import { Typography } from "@mui/material";
import React from "react";
import PastoresIMG from "./assets/img/pastores.jpg";
import "./assets/pastors.css"; // Import the CSS

function Pastors() {
  return (
    <section className="page-section pastors-section">
      <div className="container">
        <div className="pastors-container">
          {/* Image */}
          <div className="pastors-image">
            <img
              src={PastoresIMG}
              alt="Pastores de la iglesia"
            />
          </div>

          {/* Text */}
          <div className="pastors-text">
            <div>
              <Typography variant="subtitle1" component="h2" gutterBottom>
                Pastores
              </Typography>
              <Typography variant="h2" component="h2" gutterBottom>
                Agustín y Ana María De Gracia
              </Typography>
            </div>

            <Typography
              variant="body1"
              className="pastors-description"
              style={{ lineHeight: 1.6 }}
            >
              Nuestros pastores han servido fielmente a la congregación durante
              más de 18 años, guiando con amor, sabiduría y compromiso. Su
              pasión por el servicio y la enseñanza ha sido fundamental para el
              crecimiento espiritual de nuestra comunidad. Son un ejemplo de
              humildad y liderazgo cristiano.
            </Typography>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pastors;
